
<form [formGroup]="buscarMatriculaForm" (ngSubmit)="buscarMatricula()">
    <div class="row"> 
        <ca-form-field class="col-4">
            <ca-label>{{'AUTOS.BUSCADOR_MODELOS.MATRICULA.TITULO' | translate}}</ca-label>
            <input caInput formControlName="matricula" placeholder="{{'AUTOS.BUSCADOR_MODELOS.MATRICULA.TITULO' | translate}}" type="text"/>
            <ca-hint>{{'AUTOS.BUSCADOR_MODELOS.MATRICULA.HINT' | translate}}</ca-hint>
        </ca-form-field>
    </div>
    <div class="col-12 text-right mt-3 mb-3">
        <button type="submit" ca-button class="ca-btn-icon__container ml-2" data-cy="button-search">
            <ca-icon>search</ca-icon>
            {{'BUSCADOR_POLIZAS.BOTON_BUSCAR' | translate}}
        </button>
    </div>
</form>
